import React, { useState } from "react";
import ComponentCustomModal from "../../../components/common/customModal/ComponentCustomModal";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FtextField } from "../../../components/common/FtextField";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Loader from "../../../components/common/Loader";
import useISPowner from "../../../hooks/useISPOwner";
import {
  createResellerSupportNumber,
  updateResellerSupportNumber,
} from "../../../features/apiCallReseller";

const SupportNUmberDialog = ({ show, setShow, isUpdate, supportNumber }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    name: Yup.string().min(3).required(t("writeSupportName")),
    mobile: Yup.string().required(t("writeMobileNumber")),
    start: Yup.date().required(t("selectStartTime")),
    end: Yup.date().required(t("selectEndTime")),
  });

  //---> Get user & current user data form useISPOwner hooks
  const { ispOwnerId, userData } = useISPowner();

  //---> Local States
  const [isLoading, setIsLoading] = useState(false);

  const handleSupportNumberSubmition = (formValues) => {
    if (isUpdate) {
      updateResellerSupportNumber(
        dispatch,
        userData?.id,
        supportNumber?.id,
        formValues,
        setIsLoading,
        setShow,
      );
    } else {
      const sendingData = {
        ...formValues,
        reseller: userData?.id,
        ispOwner: ispOwnerId,
      };

      createResellerSupportNumber(dispatch, sendingData, setIsLoading, setShow);
    }
  };

  return (
    <ComponentCustomModal
      {...{
        show,
        setShow,
        header: isUpdate ? t("") : t("createCustomersSupporter"),
      }}
    >
      <Formik
        initialValues={{
          name: isUpdate ? supportNumber?.name : "",
          mobile: isUpdate ? supportNumber?.mobile : "",
          start: isUpdate ? new Date(supportNumber?.start) : new Date(),
          end: isUpdate ? new Date(supportNumber?.end) : new Date(),
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSupportNumberSubmition(values);
        }}
        enableReinitialize
      >
        {() => (
          <Form id="support">
            <div className="displayGrid">
              <FtextField
                type="text"
                label={t("name")}
                name="name"
                validation={"true"}
              />

              <FtextField
                type="text"
                label={t("mobile")}
                name="mobile"
                validation={"true"}
              />

              <FtextField
                {...{
                  name: "start",
                  type: "date",
                  id: "start",
                  validation: true,
                  label: t("selectStartTime"),
                  placeholderText: "HH:mm A",
                  component: "DatePicker",
                  dateFormat: "hh:mm a",
                  timeIntervals: 1,
                  showTimeSelect: true,
                  showTimeSelectOnly: true,
                }}
              />

              <FtextField
                {...{
                  name: "end",
                  type: "date",
                  id: "end",
                  validation: true,
                  label: t("selectEndTime"),
                  placeholderText: "HH:mm A",
                  component: "DatePicker",
                  dateFormat: "hh:mm a",
                  timeIntervals: 1,
                  showTimeSelect: true,
                  showTimeSelectOnly: true,
                }}
              />
            </div>

            <div className="displayGrid1 float-end mt-4">
              <button
                type="button"
                className="btn btn-secondary"
                disabled={isLoading}
                onClick={() => setShow(false)}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-success customBtn"
                disabled={isLoading}
              >
                {isLoading ? <Loader /> : "Submit"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </ComponentCustomModal>
  );
};

export default SupportNUmberDialog;
